<p class="card-list__title" *ngIf="title">{{ title }}</p>
<ul class="card-list">
  <li class="card-list__item" *ngFor="let item of items; trackBy: trackItem" [innerHTML]="item | novaMarkdown: 'inline'"></li>
</ul>
